<template>
  <div class="content-wrap">
    <keep-alive exclude="detail-index">
      <router-view></router-view>
    </keep-alive>
    <bk-tab
      class="content_tab"
      v-if="showTab"
      v-model="defaultTabIndex"
      :tab-items="tabList"
      @on-change="onTabChange"
    ></bk-tab>
  </div>
</template>

<script>
import bkTab from "@/components/bk-tab.vue";
export default {
  components: { bkTab },
  props: {},
  data() {
    return {
      curOrgId: "",
      defaultTabIndex: 0,
      showTab: true, // 显示tab
      tabList: [
        {
          value: "支部列表",
          url: "/miniParty/list"
        },
        {
          value: "支部展示",
          url: "/miniParty/carousel"
        }
      ]
    };
  },
  watch: {
    curOrgId(val) {
      this.tabList[1].query = {
        communityId: val
      };
    }
  },
  computed: {
  },
  methods: {
    onTabChange(index) {
      sessionStorage.miniPartyTabIndex = index;
      let cur = this.tabList[index];
      this.$router.replace({
        path: cur.url,
        query: cur.query
      });
    }
  },
  created() {},
  mounted() {
    this.defaultTabIndex = Number(sessionStorage.miniPartyTabIndex) || 0;
  },
  beforeRouteEnter(to, from, next) {
    // 子路由刷新时 触发 隐藏tab
    next(vm => {
      vm.showTab = !!to.meta.showTab;
    });
  },
  beforeRouteUpdate(to, from, next) {
    // 跳转到子路由时触发 隐藏所有子路由中的tab
    this.showTab = !!to.meta.showTab;
    next();
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    // 如果路由路径不在 miniParty模块 清除session缓存
    if (!/^\/miniParty/.test(to.fullPath)) {
      sessionStorage.removeItem("miniPartyTabIndex");
      sessionStorage.removeItem("miniPartyDetailIndex");
    }
    next();
  }
};
</script>
<style lang="less" scoped>
.content_tab {
  position: absolute;
  top: 30px;
  left: 20px;
}
</style>
